//
//
//
//
//
//

export default {
  name: "portalIndex",
  data(){
    return{

    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    this.$store.commit('UPDATE_PAGE_TITLE','小棉花官网');
    document.title = '小棉花官网'
  },
}



// WEBPACK FOOTER //
// ./src/components/portalIndex.vue